<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
</div>
<form class="admin-forms" [formGroup]="editTripform">
  <div class="accordion-class">
    <h5>Edit Trip</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Trip ID </mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="trip_id" readonly />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Customer ID</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="user_id" readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Customer Name</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="username" readonly />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Customer Mobile</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="mobile" readonly />
          </mat-form-field>
        </div>
      </div>

      <mat-divider class="divider_mat"></mat-divider>
      <div class="row mtb align-items-center">
        <div class="col-md-12">
          <h6>Trip Details</h6>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Trip Booking Date</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker></mat-datepicker>
            <input matInput [matDatepicker]="picker" placeholder="DD-MM-YYYY" [min]="minDate"
              formControlName="trip_booking_date" (click)="picker.open()" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <!-- <mat-error>Please Select Valid Trip Booking Date</mat-error> -->
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Vehicle No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
            <mat-select dropLocationSearchField formControlName="truck_number"
              (selectionChange)="getVehiclesList($event)" required>
              <mat-option *ngFor="let truck of truckArray" value="{{ truck._id }}">
                {{ truck.truck_number }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Driver Name</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="driver_id" readonly />
            <mat-error>Please Enter Driver Name</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Driver Number</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="driver_number" readonly />
            <mat-error>Please Enter Driver No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Truck Owner Name</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="truck_ownerName" readonly />
            <mat-error>Please Enter Truck Owner Name </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Truck Owner No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="truck_ownerNumber" readonly />
            <mat-error>Please Enter Truck Owner No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Net Quantity (Loading Point)</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="loading_point" appThreeDigitDecimalNumber />
            <!-- <mat-error>Please Enter Net Quantity Loading Point</mat-error> -->
            <mat-error></mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Net Quantity (UnLoading Point)</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input appThreeDigitDecimalNumber matInput formControlName="unloading_point" />
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Price Per Ton</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput appTwoDigitDecimaNumber formControlName="price_per_ton" required />
            <mat-error>Please Enter Price Per Ton</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Sales Order No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="sales_order_number" placeholder="Enter Sales Order Number" required
              appAlphanumericOnly toUppercase maxlength="16" />
            <mat-error>Please Enter Sales Order No </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>LR No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="lr_number" placeholder="Enter LR Number" required appAlphanumericOnly
              toUppercase maxlength="16" />
            <mat-error>Please Enter LR No</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>LR Date</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker1></mat-datepicker>
            <input matInput [matDatepicker]="picker1" placeholder="DD-MM-YYYY" [max]="maxDate" formControlName="lr_date"
              (click)="picker1.open()" />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error>Please Enter LR Date</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Tax Invoice No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="tax_invoice_no" placeholder="Enter Tax Invoice Number" required toUppercase
              maxlength="16" (keypress)="validateTaxInvoiceInput($event)" />
            <mat-error>Please Enter Tax Invoice No</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-label>DDC No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="ddc_no" placeholder="Enter DDC Number" required appAlphanumericOnly
              toUppercase maxlength="16" />
            <mat-error>Please Enter DDC No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>ePOD Received On</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker2></mat-datepicker>
            <input matInput [matDatepicker]="picker2" placeholder="DD-MM-YYYY" formControlName="epod_received_on"
              (click)="picker2.open()" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Physical POD Received On</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker3></mat-datepicker>
            <input matInput [matDatepicker]="picker3" placeholder="DD-MM-YYYY" formControlName="physical_pod_received_on"
              (click)="picker3.open()" />
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>POD Upload</mat-label>
        </div>
        <div class="col-md-3 d-flex align-items-center">
          <div (click)="uploadPODImage.click()" *ngIf="uploadPod" class="upload-container">
            <img src="../../../assets/img/upload.svg" class="upload-icon" alt="" />
            <span>Click to Upload POD</span>
          </div>
          <div [class.spinner]="podLoading"></div>

          <ng-container *ngIf="!uploadPod && podImage">
            <a [href]="podImage" target="_blank" style="margin-right: 10px;"
              *ngIf="!podImage.toLowerCase().includes('.pdf'); else pdfLink">
              <img [src]="podImage" alt="POD Preview" class="preview-img" />
            </a>
            <ng-template #pdfLink>
              <a [href]="podImage" target="_blank" style="color: #1f6fd8; margin-right: 10px; font-weight: 500;">
                <img src="../../../assets/img/elr-icon.svg" class="upload-icon" style="width: 25px;" alt="" />
                {{ podImageName || 'View POD' }}
              </a>
            </ng-template>
          </ng-container>

          <img src="../../../assets/img/cross.svg" *ngIf="!uploadPod" (click)="removeImg($event, 'POD')"
            class="cross-btn-pod" alt="" />
          <input #uploadPODImage type="file" (click)="uploadPODImage.value = ''" (change)="onUploadPOD($event)"
            hidden />
        </div>
        <div class="col-md-3">
          <mat-label>E-Way Bill No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="eway_bill_no" placeholder="Enter E-Way Bill Number" maxlength="12" minlength="12" (keypress)="validateNumericInput($event)" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-7">
    <button type="submit" [class.spinner]="loading" [disabled]="loading" class="button buttonBlue"
      (click)="UpdateTrips($event)">
      Submit
    </button>
  </div>
</form>